
'use strict';


/**
 * @pbdoc Directive
 * @name fieldFocus
 * @packageName focus-directive
 *
 * @description
 *
 * Set focus on input field with param field-focus
 *
 */
class rmFieldFocus {
	

    constructor ( ) {

		//Attributes only
        this.restrict = 'A';
    }


	/*
	 * AngularJS function for manipulating the dom element
	 */
    link ( scope, element, attributes ) {

    	//Set focus on element
  		element.focus(); 
    }
}


/*
 * Browsify connection: execute service
 * @Return {instance} A new instance of this directive
 */
module.exports = [( ) => {

	//Create new instance
	rmFieldFocus.instance = new rmFieldFocus();
	return rmFieldFocus.instance;
}];